import { Customer } from "../../../customer/shared/customer.model";
import { Employee } from "../../../login/shared/employee";
import { Enquiryno } from "../../surveyentry/shared/enquiryno.model";

export class Surveyentry {
    Id : number ;
    SurveyNo : number;
    SurveyDate : Date;
    EnquiryNo : number;
    EnquiryDate : string;
    StatusId : number;
    TrainingNo : number;
    Remarks : string;
    ProposedCenter : number;
    FirstTrainingDate : Date;
    SecondTrainingDate : Date;
    ThirdTrainingDate : Date;
    EmployeeId : number;
    EmployeeBranchId : number;
    CompanyId : number;
    SaasId : number;
    CreatedDate : Date;
    ModifiedDate : Date;
    IsActive  : boolean;
    Flag : number;

    CustomersList :   Customer[] ;

    EmployeeList : Employee[];

    EnquiryNoList : Enquiryno[];
}
